




import Vue, { PropType } from "vue";
import StripePrice from "@/lib/stripePrice";

export interface StripePriceProps {
  price: number;
  currency: string;
}

export default Vue.extend({
  name: "vc-stripe-price",
  props: {
    price: {
      type: Number as PropType<StripePriceProps["price"]>,
      default: ""
    },
    currency: {
      type: String as PropType<StripePriceProps["currency"]>,
      default: ""
    }
  },
  computed: {
    displayPrice() {
      return StripePrice.getPrice(this.currency, Number(this.price));
    }
  }
});
